import { useState } from 'react';
import { Modal, message, Form, Button, Checkbox, Select } from 'antd';
import LoaderComponent from '../../../Loader';
import API from '../../../../services/API';

export default function SubscriptionCancelModal ({
  modalVisible,
  closeModal,
  userId,
  currentSubscriptionId,
  refreshList,
  setModalVisible,
  modalLoading,
  showModalLoading }) {

    const [cancelImmediately] = useState(true);
    const labelCol = { span: 12 };
    
  const cancellationReasons = [
    { value: 'FRAUD_FIRST_PARTY_SYNTHETIC_IDENTITY',
      label: 'Confirmed Fraud - First Party Synthetic Identity' },
    { value: 'FRAUD_THIRD_PARTY_SYNTHETIC_IDENTITY',
      label: 'Confirmed Fraud - Third Party Synthetic Identity' },
    { value: 'FRAUD_IDENTITY_THEFT', label: 'Confirmed Fraud - Identity Theft' },
    { value: 'FRAUD_MISREPRESENTATION', label: 'Confirmed Fraud - Misrepresentation' },
    { value: 'FRAUD_ACCOUNT_TAKEOVER', label: 'Confirmed Fraud - Account Takeover' },
    { value: 'FRAUD_REWARDS_ABUSE', label: 'Confirmed Fraud - Rewards Abuse' },
    { value: 'FRAUD_ACH_REVERSAL', label: 'Confirmed Fraud - ACH Reversal' },
    { value: 'FRAUD_INVALID', label: 'Invalid Fraud Claim' },
    { value: 'DUPLICATE_ACCOUNT', label: 'Duplicate Account' },
    { value: 'UNABLE_VERIFY_IDENTITY', label: 'Unable to Verify Identity' },
    { value: 'TOS_DISPUTE', label: 'Violation of Terms of Service - Dispute Abuse' },
    { value: 'TOS_UNAUTHORIZED',
      label: 'Violation of Terms of Service - Unauthorized Activity' },
    { value: 'TOS_GENERAL', label: 'Violation of Terms of Service - General' },
    { value: 'CUSTOMER_REQUEST', label: 'Customer Requested' },
    { value: 'DECEASED', label: 'Customer Deceased' }
  ];

  const cancelSubscription = async (data) => {
    const { cancelImmediately, cancellationReason } = data;
    try {
      showModalLoading(true);
      await API.cancelSubscription(userId, currentSubscriptionId, cancelImmediately, cancellationReason);
      if (refreshList) refreshList();
      message.success('Successfully cancelled the Subscription.');
      showModalLoading(false);
      setModalVisible(false);
    } catch (e) {
      message.error(e.message ?? 'Unable to cancel the Subscription.');
      showModalLoading(false);
    }
  }
  
  const onFinishFailed = (error) => {
    console.log('new error', { ...error});
  };

  return (
    <Modal
        title={'Cancel Subscription Confirmation'}
        centered
        mask={true}
        maskClosable={true}
        destroyOnClose={true}
        closable={true}
        open={modalVisible}
        footer={null}
        onOk={cancelSubscription}
        onCancel={closeModal}
        className="confirm-modal"
      >
        <>
          <Form
            name="basic"
            layout="vertical"
            style={{
              maxWidth: 600,
            }}
            initialValues={{
              cancelImmediately,
              cancellationReason: undefined,
            }}
            onFinish={cancelSubscription}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <div>
              <Form.Item
                name="cancelImmediately"
                valuePropName="checked"
              >
                <Checkbox>Cancel subscription immediately?</Checkbox>

                <small>
                  <ul>
                    <li>
                      Unchecking this will cancel the user subsciption at period end and will <b>not close</b> the Customer's Ava Credit Card and/or Save & Build Credit Loan.
                    </li>
                    <li>
                      Keeping it checked will cancel the subscription of the user with immediate effect and will also <b>close</b> the Customer's Ava Credit Card and/or Save & Build Credit Loan
                    </li>
                  </ul>
              </small>
              </Form.Item>

              
              <Form.Item
                label="Cancellation Reason"
                name="cancellationReason"
                rules={[{ required: true, message: 'Please select a cancellation reason' }]}
              >
                <Select
                  placeholder="Select a reason for cancellation"
                  options={cancellationReasons}
                />
              </Form.Item>
            </div>
            <div>
                <Form.Item shouldUpdate>
                  {({ getFieldValue }) => (
                    <>
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={modalLoading || !getFieldValue('cancellationReason')}
                      >
                        Cancel Subscription
                      </Button>
                      &nbsp;
                      <Button htmlType="button" onClick={closeModal} disabled={modalLoading}>
                        Close
                      </Button>
                    </>
                  )}
                </Form.Item>
            </div>
          </Form>
          {modalLoading && <LoaderComponent />}
        </>
      </Modal>
      );
}